import {
  PlayerMeasurementRow,
  PlayerComparisons,
} from "../../generated-client/apollo";

export const PlayerMeasurementType = PlayerMeasurementRow.measurement;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PlayerMeasurementType = PlayerMeasurementRow.measurement;

export const PlayerMeasurementUnit = PlayerMeasurementRow.unit;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PlayerMeasurementUnit = PlayerMeasurementRow.unit;

export type PlayerComparisonKey = keyof PlayerComparisons;
